import _isEmpty from 'lodash/isEmpty';

import {
  setModal,
  showSnackbar,
  showTransparentLoader,
  hideLoader,
} from 'containers/store';
import { refreshFileList } from 'containers/PatientView/FileList/store';

import snackbarMessages from 'utils/snackbarMessages';
import formatFullName from 'utils/formatFullName';
import ApiManager from 'utils/ApiManager';
import fileDownload, { FILE_DOWNLOAD_ENDPOINTS } from 'utils/fileDownload';

import {
  formatFileData,
  formatFileFromAPI,
  getInitialValues,
} from 'utils/fileEditUtils';

export const initialState = {
  isLoadedPage: false,
  isSubmitting: false,
  initialValues: {
    name: '',
    note: '',
  },
  fileData: {
    addedBy: '',
    date: '',
    fileName: '',
  },
  file: null,
  isEdit: false,
  hideDownload: true,
};

export const actionTypes = {
  LOAD_PAGE_SUCCESS: 'FILE_ADD_EDIT/LOAD_PAGE_SUCCESS',
  CLEAR_STORE: 'FILE_ADD_EDIT/CLEAR_STORE',
  LOAD_FILE_DATA: 'FILE_ADD_EDIT/LOAD_FILE_DATA',
  CLEAR_FILE_DATA: 'FILE_ADD_EDIT/CLEAR_FILE_DATA',
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PAGE_SUCCESS: {
      const newState = {
        ...state,
        isLoadedPage: true,
        patientId: action.patientId,
      };

      if (!_isEmpty(action.fileData)) {
        newState.fileData = formatFileFromAPI(action.fileData);
        newState.initialValues = getInitialValues(action.fileData);
        newState.isEdit = true;
        newState.hideDownload = false;
        newState.fileId = action.fileId;
      }

      return newState;
    }

    case actionTypes.CLEAR_STORE: {
      return {
        ...initialState,
      };
    }

    case actionTypes.LOAD_FILE_DATA: {
      return {
        ...state,
        fileData: formatFileData(action.fileData, action.currentUserName),
        file: action.fileData,
        hideDownload: true,
      };
    }

    case actionTypes.CLEAR_FILE_DATA: {
      return {
        ...state,
        fileData: { ...initialState.fileData },
        file: null,
      };
    }

    default:
      return state;
  }
};

const loadPageSuccess = (patientId, fileData, fileId) => ({
  type: actionTypes.LOAD_PAGE_SUCCESS,
  patientId,
  fileData,
  fileId,
});

const clearStore = () => ({
  type: actionTypes.CLEAR_STORE,
});

const loadFileData = (fileData, currentUserName) => ({
  type: actionTypes.LOAD_FILE_DATA,
  fileData,
  currentUserName,
});

export const onDownload = () => (dispatch, getStore) => {
  const { fileId } = getStore().FileAddEdit;
  fileDownload(dispatch, fileId, FILE_DOWNLOAD_ENDPOINTS.PATIENT_DOCUMENT);
};

export const onFileUpload = (acceptedFiles, rejectedFiles) => (dispatch, getStore) => {
  const currentUser = getStore().Global.userData;
  const file = acceptedFiles[0];
  const isOneFileRejected = rejectedFiles.length === 1;
  const areManyFilesRejected = _isEmpty(acceptedFiles) && rejectedFiles.length > 1;

  if (isOneFileRejected) {
    dispatch(showSnackbar(snackbarMessages.documentTooLarge));
  } else if (areManyFilesRejected) {
    dispatch(showSnackbar(snackbarMessages.tooManyFiles));
  } else if (file) {
    dispatch(loadFileData(file, formatFullName(currentUser)));
  }
};

const clearFileData = () => ({ type: actionTypes.CLEAR_FILE_DATA });

export const onFileUnload = () => (dispatch) => dispatch(clearFileData());

export const onSubmit = (values) => async (dispatch, getStore) => {
  const {
    patientId, file, isEdit, fileId,
  } = getStore().FileAddEdit;
  const { name, note } = values;

  const url = isEdit ? `patient_documents/${fileId}` : `patients/${patientId}/documents`;

  const formData = new FormData();
  formData.append('name', name);

  if (!_isEmpty(file)) {
    formData.append('file', file);
  }

  if (note) {
    formData.append('note', note);
  }

  dispatch(showTransparentLoader());
  try {
    await ApiManager.request('post', dispatch, url, formData);
    dispatch(setModal());
    dispatch(hideLoader());
    dispatch(refreshFileList());
    dispatch(clearStore());
  } catch (error) {
    const errors = error.error.errors;
    const isErrorFile = errors.file;
    const isErrorName = errors.name;

    if (isErrorFile) {
      dispatch(showSnackbar(snackbarMessages.wrongFileFormat));
    } else if (isErrorName) {
      dispatch(showSnackbar(snackbarMessages.maxNameLength_255));
    } else {
      dispatch(showSnackbar(snackbarMessages.globalError));
    }
    dispatch(hideLoader());
  }
};

export const onCancel = () => (dispatch) => {
  dispatch(clearStore());
  dispatch(setModal());
};

const getFileData = (id) => (dispatch) => ApiManager.request('get', dispatch, `patient_documents/${id}`);

export const loadPageData = (patientId, id) => async (dispatch) => {
  dispatch(clearStore());
  let fileData = {};
  if (id) {
    fileData = await dispatch(getFileData(id));
  }
  dispatch(loadPageSuccess(patientId, fileData.data, id));
  dispatch(hideLoader());
};
